import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { CompanyService } from './company.service';
import { environment } from '../../../environments/environment';
import { DeviceData, UpdateDeviceRequest, Response } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  devicesList$: BehaviorSubject<DeviceData[] | null> = new BehaviorSubject<DeviceData[] | null>(null);
  selectedId: number | null = null;

  searchColumns: string[] = ['device_type', 'brand', 'warrantyEnds', 'userId', 'status'];
  searchQueries: string[] = ['', '', '', '', ''];
  searchQueriesInit: string[] = { ...this.searchQueries };

  sortBy: string[] = [];

  constructor(
    private readonly http: HttpClient,
    private readonly companyService: CompanyService
  ) {}

  updateDevicesList(): Subscription {
    return this.getDevicesListRequest().subscribe({
      next: (response) => {
        if (response.success && response.data) {
          this.devicesList$.next(response.data);
          this.companyService.isDevicesUpToDate$.next(true);
        }
      }
    });
  }

  private getDevicesListRequest(): Observable<Response<DeviceData[]>> {
    const params = new URLSearchParams();
    this.sortBy.forEach((s: any) => params.append('sortBy', s));

    return this.http.get<Response<DeviceData[]>>(`${environment.baseUrl}/devices/list?${params.toString()}`);
  }

  createDeviceRequest(device: UpdateDeviceRequest): Observable<Response<DeviceData>> {
    return this.http.post<Response<DeviceData>>(`${environment.baseUrl}/devices`, device);
  }

  updateDeviceRequest(id: number, device: UpdateDeviceRequest): Observable<Response<DeviceData>> {
    return this.http.put<Response<DeviceData>>(`${environment.baseUrl}/devices/${id}`, device);
  }

  removeDeviceRequest(id: number): Observable<Response<any>> {
    return this.http.delete<Response<any>>(`${environment.baseUrl}/devices/${id}`);
  }

  clearData() {
    this.devicesList$.next(null);
    this.searchQueries = this.searchQueriesInit;
  }
}
